import { render, staticRenderFns } from "./RegisterNewHotel.vue?vue&type=template&id=92ca6b82&"
import script from "./RegisterNewHotel.vue?vue&type=script&lang=js&"
export * from "./RegisterNewHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92ca6b82')) {
      api.createRecord('92ca6b82', component.options)
    } else {
      api.reload('92ca6b82', component.options)
    }
    module.hot.accept("./RegisterNewHotel.vue?vue&type=template&id=92ca6b82&", function () {
      api.rerender('92ca6b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/RegisterNewHotel.vue"
export default component.exports